import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components/macro';
import useMenu from '../../../../hooks/api/queries/useMenu';
import { useMenuContext } from '../../../../hooks/context/useMenuContext';
import { COLORS } from '../../../../styles/colors';
import { breakpoint, max_width } from '../../../../styles/constants';
import { SLUG_CATEGORY } from '../../../../styles/slugs';
import { appendCommitHash } from '../../../../utils/appendHash';
import getPageOffset from '../../../../utils/getPageOffset';
import { WImage } from '../../../ui/image/Image';
import { SubMenu } from '../../subMenu/SubMenu';
import { MenuNav } from '../MenuNav';

export const MainMenu: React.FC = () => {
  const { open, setOpen, selected } = useMenuContext();
  const { data } = useMenu();
  const navigate = useNavigate();

  var element = document.getElementById('root');
  const offset = getPageOffset(element);
  let topOffset = window.scrollY > offset ? window.scrollY - offset : 0;

  if (!data) return null;

  return (
    <Background open={open} topOffset={topOffset}>
      <Container>
        <MinContainer>
          <MenuNav />
        </MinContainer>
        <MinContainer>{selected !== -1 && <SubMenu />}</MinContainer>
        <RightContainer>
          {selected !== -1 &&
            (data[selected].imageLocalized?.path ||
              data[selected].imageDefault?.path) && (
              <PushContainer
                onClick={() =>
                  navigate(
                    appendCommitHash(
                      `/${SLUG_CATEGORY}/${data[selected].slug}`,
                    ),
                  )
                }
              >
                <WImage
                  image={
                    data[selected].imageLocalized?.path
                      ? data[selected].imageLocalized
                      : data[selected].imageDefault
                  }
                  background
                />
              </PushContainer>
            )}
          <Pointer>
            <FontAwesomeIcon
              icon={faTimes}
              onClick={() => setOpen(false)}
              size={'xs'}
            />
          </Pointer>
        </RightContainer>
      </Container>
    </Background>
  );
};

export const Pointer = styled.div`
  cursor: pointer;
  margin-left: auto;
  margin-bottom: auto;
  font-size: 1.5rem;
  margin-top: -0.2rem;

  &:hover {
    color: ${COLORS.red};
  }
`;

const Background = styled.div<{ open: boolean; topOffset: number }>`
  display: none;
  @media (min-width: ${breakpoint}) {
    display: ${({ open }) => (open ? 'block' : 'none')};
  }

  z-index: 2;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  position: absolute;
  left: 0;
  top: ${({ topOffset }) =>
    topOffset ? `calc(52px + ${topOffset}px)` : '52px'};
  height: calc(100% - 52px);
  padding-top: 2.5rem;
  width: 100%;
`;

const Container = styled.div`
  position: relative;
  z-index: 2;

  max-width: ${max_width};
  min-height: 80vh;
  margin-inline: auto;
  display: flex;
  flex-direction: row;
  > :first-child {
    margin-right: 1.4rem;
  }
`;

const MinContainer = styled.div`
  flex: 3.5;
`;

const PushContainer = styled.div`
  cursor: pointer;
  width: 18rem;
  img {
    width: 100%;
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 0.5rem;
  flex: 4;
  > div:first-child {
    flex: 1;
  }

  > div:last-child {
    display: flex;
    justify-content: flex-end;
  }
`;
